import Vue from 'vue'
import { DateTime } from 'luxon'

Vue.filter('week', week)

function week (day) {
  const dateTime = DateTime.fromISO(day)
  return dateTime.weekNumber + '/' + dateTime.weekYear
}

export default week
